import { lazy } from 'react';

const ProductManagement = lazy(() => import('./ProductManagement'));

export default ProductManagement;
